const Actions = {
  Navigate: {
    DO: 'v.period-new.actions.navigate.do',
    CONTINUE: 'v.period-new.actions.navigate.continue',
    PREVIOUS: 'v.period-new.actions.navigate.previous'
  },
  Cancel: {
    DO: 'v.period-new.actions.cancel.do'
  },

  Form: {
    CHANGE: 'v.period-new.actions.form.change'
  },

  Steps: {
    Completed: {
      UPDATE: 'v.period-new.actions.steps.completed.update'
    },
    ActiveView: {
      SET: 'v.period-new.actions.steps.active-view.set'
    }
  }
};

const Mutations = {
  CLEAR: 'v.period-new.mutations.clear',
  INITIALIZE: 'v.period-new.mutations.initialize',

  ActiveView: {
    SET: 'v.period-new.mutations.active-view.set',
    CLEAR: 'v.period-new.mutations.active-view.clear'
  },

  Steps: {
    Completed: {
      SET: 'v.period-new.mutations.steps.completed.set'
    },
    Active: {
      SET: 'v.period-new.mutations.steps.active.set'
    },
    CLEAR: 'v.period-new.mutations.steps.clear'
  },

  Form: {
    CHANGE: 'v.period-new.mutations.form.change'
  },

  SET_CORRESPONDING_ROS: 'v.period-new.mutations.set-corresponding-ros'
};

const Views = {
  NewPeriodInputForm: 'v.period-new.views.new-period-form',
  NewPeriodConfirmation: 'v.period-new.views.new-period-confirmation'
};

export default {
  Actions,
  Mutations,
  Views
};
